export default {
  fields: {
    code: 'Kod',
    tag: 'Tag',
    type: 'Typ',
    discount_type: 'Typ rabatu',
    discount: 'Rabat',
    usage_threshold: 'Próg użycia',
    quantity: 'Ilość',
    expires_at: 'Wygasa',
    customers: 'Klienci',
    purchases: 'Zamówienia',
    sales: 'Sprzedaż',
    level: 'Poziom',
    max_discount: 'Maks. rabat',
  },
  tags: {
    master: 'Master',
    campaign: 'Kampania',
    one_time: 'Jednorazowy',
  },
  types: {
    single_use: 'Jednorazowy',
    multi_use: 'Wielokrotny',
    unknown: 'Nieznany',
  },
  discount_types: {
    fixed_amount: 'Stała kwota',
    percentage: 'Procent',
    unknown: 'Nieznany',
  },
  labels: {
    discount: 'Rabat',
    usage_threshold: 'Próg użycia',
    company: 'Firma',
  },
  collecting_emails: {
    description:
      'Tutaj możesz skonfigurować jednorazowy kod promocyjny generowany dla nowych użytkowników podczas rejestracji na stronie.',
  },
  buttons: {
    edit: 'Edytuj',
  },
  toasts: {
    successfully_deleted: 'Pomyślnie usunięto ustawienia kodu promocyjnego',
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
